// Export routing configuration as the main export
export * from './routing';
